import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { ConsumedEvent } from 'shell/models/consumed-event';
import { HttpResponse } from 'shell/models/http-response';
import { ConsumedEventForm } from 'system/components/published-events/form-consumed-event';

export const transformConsumedEvent = (
  response: AxiosResponse<HttpResponse<ConsumedEvent>>
): ConsumedEventForm => {
  const data: ConsumedEvent = response.data.payload || {};
  const res: ConsumedEventForm = {
    idConsumedEvent: data?.id,
    idPublishedEvent: data?.idEventoPubblicato,
    eventTypeCode: data?.descrizioneTipoEvento,
    dateTimeConsummationEnd: data?.fineElaborazione
      ? DateTime.fromISO(data?.fineElaborazione)
      : null,
    eventTypeDestination: data?.descrizioneTipoDestinazione,
    numberAttempts: data?.numeroRollbackEffettuati,
    outcome: data?.esito,
    state: data?.statoElaborazione,
    progressive: data?.progressivo,
    dateTimeConsummationStart: data?.inizioElaborazione
      ? DateTime.fromISO(data?.inizioElaborazione)
      : null,
    subscriber: data?.descrizioneSottoscrittore?.toString(),
  };
  return res;
};
